import React from 'react';
import JavascriptNumbersMethods from './JavascriptNumbersMethods.jsx';
import JavascriptNumbersProperties from './JavascriptNumbersProperties.jsx';
import JavascriptNumbersReference from './JavascriptNumbersReference.jsx';
import JavascriptMathReference from './JavascriptMathReference.jsx';
import JavascriptRandom from './JavascriptRandom.jsx';
import JavascriptBigint from './JavascriptBigint.jsx';
import JavascriptBitwise from './JavascriptBitwise.jsx';

export default function JsNumbers() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Numbers</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/numbers/methods' className='underline'>JS Number Methods</a></li>
<li><a href='/javascript/numbers/properties' className='underline'>JS Number Properties</a></li>
<li><a href='/javascript/numbers/reference' className='underline'>JS Number Reference</a></li>
<li><a href='/javascript/math/reference' className='underline'>JS Math Reference</a></li>
<li><a href='/javascript/random' className='underline'>JS Random</a></li>
<li><a href='/javascript/bigint' className='underline'>JS BigInt</a></li>
<li><a href='/javascript/bitwise' className='underline'>JS Bitwise</a></li>
      </ul>
    </div>
  );
}
